import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SectionSocialContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getSocial(id: string): Observable<any> {
    return this.getSocialContents(id).pipe(
      map(res => this.buildReponseSocialObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.querySocialContents[0].flatData;
  }

  private getSocialContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        querySocialContents(filter: "id eq '${id}'") {
          data {
            nome {
              iv
            }
            titulo {
              iv
            }
            cards {
              iv {
                titulo
                descricao
                imagem {
                  url
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildReponseSocialObject(response: any) {
    let cards = [];

    if (response?.cards) {
      cards = response.cards.iv.map((card: any) => {
        return {
          title: card.titulo,
          description: card.descricao,
          image: card.imagem && card.imagem[0] ? card.imagem[0].url : ''
        };
      });
    }
    return {
      cards,
      title: response?.titulo ? response.titulo.iv : ''
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
